import {isNil} from 'ramda';

import {LocalizedContentValues} from '../types/GeneralSettingsFormValues';

interface LocalizedContentEntry {
  language: string;
  titleExtension: string | null;
  subtitle: string | null;
  description: string | null;
}

interface DefaultLanguageTitleSeed {
  language: string | null;
  titleExtension: string | null;
  subtitle: string | null;
}

/**
 * Builds the per-language form defaults. When the default content language has no title
 * extension or subtitle of its own, it is seeded from the general `title_extension` / `subtitle`
 * attribute so the value the backend would publish as fallback is visible and editable in that
 * language tab.
 */
export function buildLocalizedContentDefaults(
  enabledLanguages: string[],
  localizedData: Array<LocalizedContentEntry> | undefined,
  defaultLanguageTitleSeed?: DefaultLanguageTitleSeed
): Record<string, LocalizedContentValues> {
  const result: Record<string, LocalizedContentValues> = {};
  for (const lang of enabledLanguages) {
    const existing = localizedData?.find((item) => item.language === lang);
    const isSeededLanguage = lang === defaultLanguageTitleSeed?.language;
    const seededTitle =
      isSeededLanguage && isNil(existing?.titleExtension)
        ? (defaultLanguageTitleSeed?.titleExtension ?? null)
        : null;
    const seededSubtitle =
      isSeededLanguage && isNil(existing?.subtitle)
        ? (defaultLanguageTitleSeed?.subtitle ?? null)
        : null;
    result[lang] = {
      titleExtension: existing?.titleExtension ?? seededTitle,
      subtitle: existing?.subtitle ?? seededSubtitle,
      description: existing?.description ?? null,
    };
  }
  return result;
}
